import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Space, Button, toast, Loader, ModalContent,Conditional } from "@cashfree-intl/coherent";

import { StyledDomainCard, StyledScreenModal } from "containers/ProductTour/component/Shopify/SecondDay/styled";
import { SubStepDescription } from "containers/CheckoutJourney/screens/styled";

import { getInstalledAppsData, getMerchantProfileData } from "containers/ProductTour/actions";
import { sendAnalyticsData } from "containers/ProductTour/helper";

import { getItemFromLocalStorage } from "utils/common";
import { ONE_CASHFREE_PAYMENTS_APP, PACKAGE_REF, DOMAIN_REF } from "containers/ProductTour/constants";
import { WHITELISTING_STATUS } from "containers/ProductTour/type";
import { INTEGRATION_STATUS } from "containers/CheckoutJourney/util/constant";

import Whitelisting from "containers/Whitelisting";
import { SubstepComponentProps, WhitelistingData } from 'containers/CheckoutJourney/types';



const WhitelistDomain = ({ substep, updateStatus }: SubstepComponentProps) => {
  const dispatch = useDispatch();
  const [isPluginActivated, setIsPluginActivated] = useState<boolean>(false);
  const [whiteListingData, setWhiteListingData] = useState<WhitelistingData[] | null>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const merchantId = getItemFromLocalStorage("merchantId");

  const onCloseMethodAndDomain = () => {
    fetchMerchantData();
    setModalOpen(false);
  };

  const openMethodAndDomain = () => {
    setModalOpen(true);
  };

  useEffect(() => {
    setLoader(true);
    dispatch(
      getInstalledAppsData({
        successCb: (response: any) => {
          const apps = response?.shopifyDetails?.installedApps;
          setIsPluginActivated(
            Array.isArray(apps) && apps.includes(ONE_CASHFREE_PAYMENTS_APP)
          );
          setLoader(false);
        },
        errorCb: (error: any) => {
          toast.error(error?.message);
          setLoader(false);
        },
      })
    );
    sendAnalyticsData("whitelistSitePackageButtonClicked");
  }, []);

  useEffect(() => {
    fetchMerchantData();
  }, [isPluginActivated]);

  const fetchMerchantData = () => {
    dispatch(
      getMerchantProfileData({
        data: { merchantId },
        successCb: (response: any) => {
          const { whitelistingResult } = response;
          if (whitelistingResult) {
            const validDomains = whitelistingResult.filter((item: WhitelistingData) =>
              [DOMAIN_REF, PACKAGE_REF].includes(item.referenceType)
            );
            const requiredDomains = validDomains.filter(
              (item) =>
                item.referenceValue !== null &&
                [WHITELISTING_STATUS.IN_REVIEW, WHITELISTING_STATUS.APPROVED].includes(item.ticketStatus)
            );
            setWhiteListingData(requiredDomains);
          }
        },
        errorCb: (error: any) => toast.error(error?.message),
      })
    );
  };

  const markAsDone = () => {
    updateStatus(substep.id, INTEGRATION_STATUS.COMPLETED);
  };

  return (
    <Space gap={2.5} direction="column" className="mt-2">
      <SubStepDescription color="bodyLight">{substep.description}</SubStepDescription>
      <Conditional if={loader}>
        <Loader active inline className="ml-2" />
      </Conditional>
      <Conditional if={!loader && whiteListingData?.length > 0}>
        {whiteListingData?.map((data) => (
          <Space key={data.referenceValue} gap={1} direction="column" fullWidth>
            <StyledDomainCard gap={1} justifyContent="space-between" alignItems="center" className="my-1">
              <SubStepDescription className="w-600" color="primary">
                {data.referenceValue}
              </SubStepDescription>
            </StyledDomainCard>
          </Space>
        ))}
      </Conditional>
      <Space gap={1}>
        <Button primary onClick={markAsDone}>Looks good</Button>
        <Button link onClick={openMethodAndDomain}>Add new</Button>
      </Space>
      <Conditional if={modalOpen}>
        <StyledScreenModal open={modalOpen} onClose={onCloseMethodAndDomain}>
          <ModalContent>
            {/* @ts-ignore */}
            <Whitelisting showFromShopify={true} onCloseShopifyModal={onCloseMethodAndDomain}/>
          </ModalContent>
        </StyledScreenModal>
      </Conditional>
    </Space>
  );
};

export { WhitelistDomain };